export const transformLowercase = {
	textTransform: 'lowercase',
	'&::placeholder': {
		textTransform: 'none',
	},
};
